import React, { createContext, useState, useEffect, useContext } from 'react';
import { useCoreStateContext } from 'spark-core-dx/contexts';
import { ItemServiceFactory } from 'spark-core-dx/services';
import { useGenericManager } from 'spark-core-dx/hooks';

export const XChatDomainContext = createContext();

export function XChatDomainContextProvider({ children }) {
    const coreState = useCoreStateContext();
    
    useEffect(() => {
        return () => {
            coreState.clear()
        }
    }, [])

    return (
        <XChatDomainContext.Provider value={'Test'}>
            {children}
        </XChatDomainContext.Provider>
    );
}
export const useXChatDomainContext = () => useContext(XChatDomainContext);